/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  abandonedCheckout,
  outlet,
  orders,
  refunds,
} from '../assets/svg';
import { SvgCoupons, SvgDashboard, SvgDelivery, SvgLoyalty, SvgOrders, SvgOutlet, SvgPayments, SvgProducts, SvgPromotions, SvgSettings, SvgUsers, SvgVendors, SvgCompanies } from '../assets/svg/general';


export const navLinks = [
  {
    name: 'Dashboard',
    path: '/dashboard/',
    icon: SvgDashboard,
    restrictions: ['OPERATIONS', 'MARKETING', 'INITIATOR'],
  },
  {
    name: 'vendors',
    path: '/dashboard/vendors',
    icon: SvgVendors,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'outlets',
    path: '/dashboard/outlets',
    icon: SvgOutlet,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'orders',
    path: '/dashboard/orders',
    icon: SvgOrders,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'products',
    path: '/dashboard/products',
    icon: SvgProducts,
    restrictions: ['INITIATOR'],
  },
  {
    name: 'payments',
    path: '/dashboard/payments',
    icon: SvgPayments,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'users',
    path: '/dashboard/users',
    icon: SvgUsers,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'delivery',
    path: '/dashboard/delivery',
    icon: SvgDelivery,
    restrictions: [],
  },
  {
    name: 'promotions',
    path: '/dashboard/promotions',
    icon: SvgPromotions,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'email outreach',
    path: '/dashboard/outreach',
    icon: SvgPromotions,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'coupons & gift cards',
    path: '/dashboard/coupons',
    icon: SvgCoupons,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'loyalty program',
    path: '/dashboard/loyalty-program',
    icon: SvgLoyalty,
    restrictions: ['OPERATIONS', 'INITIATOR'],
  },
  {
    name: 'companies',
    path: '/dashboard/platform/companies',
    icon: SvgCompanies,
    superAdminOnly: true,
    restrictions: [],
  },
];

export const naira = '₦';
